<template>
  <vertical-stack class="product-links">
    <h3 class="heading-small">
      {{ $t(`links.heading`) }}
    </h3>

    <vertical-stack>
      <!-- Mobile -->
      <vertical-stack v-if="!isDesktop && product === ProductType.Accounts">
        <div class="paragraph-content">
          {{ $t(`links.go_to_mobile`) }}
        </div>
        <horizontal-stack>
          <apple-store-badge v-if="isIOS" />
          <google-play-badge v-if="isAndroid" />
        </horizontal-stack>
      </vertical-stack>

      <!-- Store -->
      <vertical-stack v-if="product === ProductType.Accounts || product === ProductType.Web">
        <paragraph-content keypath="links.go_to_store" />
        <store-badge />
      </vertical-stack>

      <!-- Web -->
      <vertical-stack v-if="isDesktop && (product === ProductType.Accounts || product === ProductType.Store)">
        <paragraph-content keypath="links.go_to_web" />
        <webapp-badge @click.prevent="redirectToWebOrLogin" />
      </vertical-stack>
    </vertical-stack>
  </vertical-stack>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import {
  useProduct, useDeviceInfo,
  VerticalStack, HorizontalStack, AppleStoreBadge,
  GooglePlayBadge, StoreBadge, WebappBadge
} from 'ihunter-pathfinder-components';
import { useI18n } from 'vue-i18n';
import ParagraphContent from './ParagraphContent.vue';
import { useRouteManager } from '../composables/useRouteManager';
import DeviceDetector from "device-detector-js";

const { isDesktop, isAndroid, isIOS } = useDeviceInfo();
const { product, ProductType } = useProduct();
const { redirectToWebOrLogin } = useRouteManager();

</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use '../styles/Accounts' as Accounts;

@include Accounts.Default;

.vertical-stack {
  gap: Pathfinder.$space-200;

  .vertical-stack {
    gap: Pathfinder.$space-300;

    .vertical-stack {
      gap: Pathfinder.$space-150;
    }
  }
}
</style>